<template>
  <nav>
    <!-- START::APP_BAR -->
    <v-app-bar color="#111722" app>
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
        color="white"
      ></v-app-bar-nav-icon>
      <v-container
        class="d-flex parent_width justify-space-between justify-md-start flex-row py-0 align-center mx-1 px-0 px-sm-1"
        fluid
      >
        <v-toolbar-title
          class="pl-0"
          @click="redirectTo('/')"
          style="cursor: pointer"
        >
          <div class="d-flex align-center pl-md-6">
            <v-img
              class="hidden-sm-and-down"
              src="../../assets/movie/white-02.jpg"
              width="50"
              height="50"
            ></v-img>
            <span
              class="white--text special_font logo__text ml-2 hidden-sm-and-down"
              ><span class="font-weight-bold">Movies </span
              ><span class="font-weight-bold" style="color: rgb(56 102 170)"
                >Hunter</span
              ></span
            >
          </div>
          <v-img
            class="hidden-md-and-up"
            src="../../assets/movie/white-02.jpg"
            max-width="50"
          ></v-img>
        </v-toolbar-title>
        <div class="just_home hidden-md-and-up" v-if="C_currentRouter">
          <span class="white--text ml-2 special_font"
            ><span class="font-weight-bold">Movies</span
            ><span class="font-weight-bold" style="color: rgb(56 102 170)"
              >Hunter</span
            ></span
          >
        </div>
        <!-- class="hidden-md-and-up" -->
        <v-spacer
          :class="{ 'hidden-md-and-up': $route.path !== '/' }"
          class="thespacer"
          v-if="C_currentRouter && false"
        ></v-spacer>
        <!-- <v-icon
          color="grey"
          large
          class="mr-1 hidden-md-and-up"
          v-if="C_currentRouter"
          >mdi-movie-open-outline</v-icon
        > -->

        <div class="btn_group ml-8 hidden-sm-and-down">
          <v-btn
            v-for="(item, i) in itemsData.links"
            :key="i"
            class="mx-1 nav_font"
            active-class="thecolor"
            color="white"
            text
            @click="redirectTo(item.route)"
            :input-value="$route.path==item.route"
          >
            <span class="text-capitalize">{{ item.title }}</span>
          </v-btn>
        </div>
        <v-spacer v-if="!C_currentRouter"></v-spacer>
        <div
          class="search"
          v-if="!C_currentRouter"
          :class="{ increase_search_size: isSearchInputFocused }"
        >
          <!-- <v-text-field append-icon="mdi-magnify" label="Search"></v-text-field> -->
          <v-text-field
            :label="
              $vuetify.breakpoint.mdAndUp
                ? 'Search Movie (press /)'
                : 'Search Movie'
            "
            large
            @focus="isSearchInputFocused = true"
            @blur="isSearchInputFocused = false"
            @keydown.enter="
              searchResult();
              fetchSearch(search);
            "
            solo
            background-color="#283241"
            dark
            @click:append="
              searchResult();
              fetchSearch(search);
            "
            ref="search_input"
            rounded
            v-model="search"
            hide-details
            append-icon="mdi-magnify"
            class="mx-2 search_settings"
            dense
          >
            <template v-slot:append>
              <v-slide-x-transition>
                <v-icon
                  @click="
                    searchResult();
                    fetchSearch(search);
                  "
                  size="20"
                  v-if="search"
                  >mdi-magnify</v-icon
                >
              </v-slide-x-transition>
            </template>
          </v-text-field>
          <!-- END::______AUTOCOMPLETE -->
        </div>
      </v-container>
      <!-- <v-avatar color="primary" size="35" class="hidden-sm-and-down">
        <span>MS</span>
      </v-avatar> -->
    </v-app-bar>
    <!-- START::NAVIGATION_DRAWER -->
    <v-navigation-drawer app color="#111722" v-model="drawer" temporary>
      <v-sheet height="80" color="#111722">
        <v-card-text class="d-flex align-center justify-space-between">
          <v-img src="@/assets/movie/white-02.jpg" max-width="50px" contain />
          <v-btn
            color="#202a3d"
            fab
            small
            text
            class="d-block ml-auto"
            @click="drawer = false"
          >
            <v-icon color="white" size="20"> mdi-close </v-icon>
          </v-btn>
        </v-card-text>
      </v-sheet>
      <v-divider style="border-color: #8080802e"></v-divider>
      <v-list nav>
        <v-list-item
          v-for="(item, i) in itemsData.links"
          :key="i"
          link
          active-class="thecolor"
          class="white--text"
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-btn block color="#8080802e">
            <v-icon color="white">mdi-emoticon-outline</v-icon>
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>
  </nav>
</template>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import data from "@/db/movieData.json";
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  data: () => ({
    itemsData: data,
    drawer: false,
    searchList: [],
    loading: false,
    isLoading: false,
    currentRouter: "home",
    isSearchInputFocused: false,
    firstLoad: true,
    items: ["omar", "ahmed", "sayed"],
    model: null,
    search: "",
    apiKey: "194d8a67379374e13e12c99420c19098",
    select: null,
    states: [
      "Alabama",
      "Alaska",
      "American Samoa",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District of Columbia",
      "Federated States of Micronesia",
      "Florida",
      "Georgia",
      "Guam",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Marshall Islands",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Northern Mariana Islands",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Palau",
      "Pennsylvania",
      "Puerto Rico",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virgin Island",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ],
  }),
  methods: {
    ...mapMutations(["M_changeImageLoaded"]),
    redirectTo(path) {
      if (this.$route.path == path) return;
      this.$router.push({ path }).then(() => {
        this.$vuetify.goTo(0, {
          duration: 1000,
        });
      });
    },
    focusSearchInputWithKeyboardShortcut() {
      this.$nextTick(() => {
        window.addEventListener("keydown", (e) => {
          if (e.key !== "/") return;
          if (!this.$refs.search_input) {
            return;
          } else {
            this.$refs.search_input.focus();
            e.preventDefault();
          }
        });
      });
    },
    async fetchSearch(searcharg) {
      if (this.search != "") {
        await axios
          .get(
            `https://api.themoviedb.org/3/search/movie?query=${searcharg}&api_key=${this.apiKey}`
          )
          .then((resp) => {
            this.searchList = resp.data.results;
            this.A_searchResult(resp.data.results);
            this.M_changeImageLoaded();
          });
        this.search = "";
      }
    },
    querySelections(v) {
      this.loading = true;
      setTimeout(() => {
        this.items = this.getList.filter((e) => {
          return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
        });
        this.loading = false;
      }, 500);
    },
    increaseSize() {
      let searchButton = document.querySelector(".search");
      searchButton.classList.add("increase_search_size");
    },
    shrinkSize() {
      let searchButton = document.querySelector(".search");
      searchButton.classList.remove("increase_search_size");
    },
    getFreeSpaceOfContainer() {
      let parent = document.querySelector(".parent_width");
      let assignWidth = 0;
      parent.children.forEach((el) => {
        let width = el.offsetWidth; // or use style.width
        assignWidth += width;
      });
    },
    searchResult() {
      if (this.search != "") {
        // console.log("yessss Hellooooooo");
        if (this.$route.name === "moviedetail") {
          this.$router.replace({ query: { q: this.search } });
          this.A_changeSkeletonLoading(true);
          setTimeout(() => {
            this.A_changeSkeletonLoading(false);
            window.scrollTo({
              behavior: "smooth",
              top: 0,
            });
          }, 2000);
        } else {
          // this.A_changeSkeletonLoading(true);
          setTimeout(() => {}, 2000);
          this.$router
            .push({
              name: "moviedetail",
              params: { id: this.search },
              query: { q: this.search },
            })
            .then(() => {
              this.$vuetify.goTo(0, {
                duration: 750,
              });
            })
            .catch((err) => err);
        }
        localStorage.setItem("searchKey", this.search);
        // this.search = "";
      }
    },
    ...mapActions([
      "A_searchResult",
      "A_changeSkeletonLoading",
      "A_enableDialog",
    ]),
    checkCurrentRouter() {
      // console.log(this.$route.name == "home");
      return this.$route.name == "home";
    },
  },
  mounted() {
    this.focusSearchInputWithKeyboardShortcut();
    this.checkCurrentRouter();
    if (localStorage.getItem("searchKey")) {
      this.search = localStorage.getItem("searchKey");
      this.fetchSearch(localStorage.getItem("searchKey"));
    }
  },
  computed: {
    C_currentRouter() {
      return this.$route.name == "home";
    },
    ...mapState({
      S_searchResult: (store) => store.movie.S_searchResult,
    }),
    getList() {
      let sol = this.searchList.map((el) => {
        // console.log("as", el.original_title);
        return el.original_title;
      });
      // console.log("as", sol);
      return sol;
    },
    getImage() {
      let sol = this.searchList.map((el) => {
        // console.log("as", el.original_title);
        return el.poster_path;
      });
      // console.log("as", sol);
      return sol;
    },
    barScroll() {
      return window.scrollY == 0;
    },
  },
  created() {
    const readyHandler = () => {
      if (document.readyState == "complete") {
        setTimeout(() => {
          this.firstLoad = false;
        }, 1500);
        document.removeEventListener("readystatechange", readyHandler);
      }
    };
    document.addEventListener("readystatechange", readyHandler);
    readyHandler();
    // console.log(this.S_skeletonLoading);
  },
};
</script>

<style lang="scss" scoped>
.search {
  // max-width: 200px;
  transition: all 0.3s;
  transition-timing-function: cubic-bezier(0.68, -0.55, 0.27, 1.55);
  @media (min-width: 960px) {
    max-width: 300px;
    // transition: all 2s !important;
    // min-width: 800px !important;
    width: 80%;
  }
}
.result {
  ul {
    width: 200px;
    height: 200px;
    display: block;
    margin-left: auto;
    transform: translateX(-109px);
    background: red;
  }
}
nav {
  background: #111722;
}
.increase_search_size {
  @media (max-width: 959px) and (min-width: 835px) {
    max-width: 800px !important;
  }
  @media (max-width: 835px) and (min-width: 650px) {
    max-width: 500px !important;
  }
  @media (max-width: 650px) and (min-width: 535px) {
    max-width: 400px !important;
  }
  @media (min-width: 960px) and (max-width: 1100px) {
    max-width: 350px !important;
    width: 80%;
  }
  @media (min-width: 1100px) {
    max-width: 480px !important;
    width: 80%;
  }
  // transition: all 0.3s;
  // transition: all 0.3s;
  // min-width: 400px !important;
}
.search_settings {
  box-shadow: none !important;
  border-radius: 10px !important;
}
@media (max-width: 959px) {
  .search {
    width: 80%;
    max-width: 300px;
  }
}
@media (max-width: 600px) {
  .logo__text {
    font-size: smaller;
  }
}
.thecolor {
  background: #202a3d;
}
@import url("https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Open+Sans:wght@300;400;500;600;700&family=Righteous&display=swap");
.special_font {
  // font-family: "Josefin Sans", sans-serif !important;
  font-family: "Righteous", cursive !important;
}
</style>
